import { TableColumn } from "element-ui";

//中文
export default {
  userDrawer:{ //抽屉导航
    data:[
      {name:'首页'},
      {name:'搜索'},
      {name:'分类'},
      {name:'购物车'},
      {name:'收藏'},
      {name:'我的'},
      {name:'语言'},
    ],
    language:[
      {name:'中文'},
      // {name:'英文'},
      // {name:'法文'},
      // {name:'泰语'},
      // {name:'老挝语'},
      {name:'西班牙语'}
    ]
  },
  order:{
    invoiceInfo: '发票信息',
    invoiceType: '发票类型',
    generalInvoice: '普通发票',
    specialInvoice: '专用发票',
    invoiceTip: '数电普通发票与纸质发票具有相同的法律效力，可以报销、售后、维修凭证。使用数电普通发票，不限次数，更为便捷。',
    invoiceHeader: '发票抬头',
    personal: '个人',
    company: '企业',
    inputPersonalHeader: '请输入发票抬头',
    inputCompanyHeader: '请输入单位名称',
    inputDutyNumber: '请输入纳税人识别号',
    inputDutyNumberWarn: '请输入纳税人识别号',
    email: '电子邮箱',
    inputEmail: '请输入邮箱',
    inputEmailWarn: '请输入正确的电子邮箱',
    inputHeaderNameWarn: '请输入发票抬头',
    save: '保存',
    cancel: '取消',
    submitting: '提交中...',
    invoiceDetail: '发票详情',
    headerType: '抬头类型',
    taxNumber: '税号',
    invoiceAmount: '发票金额',
    invoiceStatus: '发票状态',
    applyTime: '申请时间',
    invoiceImage: '发票图片',
    clickToPreview: '点击查看大图',
    close: '关闭'
  },
  page:{
    index:{ //首页
      navTitle: '首页',
      mainNav:[
        {name:'分类'},
        {name:'收藏'},
        {name:'订单'},
        {name:'地址'},
      ],
      coupons:'优惠券',
      titProduct:'主打商品',
      titNow:'热卖商品',
      titCate:'特色分类',
      titBtn:'查看所有',
      titAlso:'可能喜欢',
      couponDesc:'订单金额满',
      received:'已领取',
      orMore:'更多',
      viewDetails:'查看详情',
      recommended: '特色商品',
      promotions: '促销商品',
      trackOrder: '订单查询',
      onView:'查看商品',
      collectSite: '收藏本站',
      applyFor: '申请入驻',
      mobileMall: '手机商城',
      news: '新闻资讯',
      shopStreet: '店铺街',
      customerService: '客服',
      top: '回到顶部',
      topOne: '排行榜',
      footer1: '品种齐全，购物轻松',
      footer2: '多仓直发，极速配送',
      footer3: '正品行货，精致服务',
      footer4: '天天低价，畅选无忧',
      address: 'Paso 91, C1031ABB Cdad. Autónoma de Buenos Aires',
      icp: '网药平台备字〔2023〕第000002号©2025 shoping',
      aboutUs: '关于我们',
      contactUs: '联系我们',
      userAgreement: '用户协议',

    },
    news: { // 新闻
      navTitle: '新闻资讯',
      sidebarTitle: '热门资讯'
    },
    trackOrder: {
      tips: '要跟踪您的订单，请在下面的框中输入您的订单ID并按“跟踪”按钮。这是在你的收据和你应该收到的确认邮件中给你的。',
      title: '查询订单',
      orderId: '订单Id',
      email: '电子邮件',
      btnTxt: '查询',
      successTip: '查询成功，已发送到您的邮箱'
    },
    goodsDetail:{ //商品详情
      search:'搜索商品',
      sales:'销量',
      oldPrice:'原价',
      inventory:'库存',
      coupons:'优惠券',
      choose:'已选择',
      choose1:'请选择',
      Reviews:'用户评价',
      good:'好评',
      details:'商品详情',
      recommend:'优品推荐',
      home:'首页',
      like:'收藏',
      cart:'购物车',
      addCart:'加入购物车',
      buyNow:'立即购买',
      soldOut:'已售罄',
      sold: '已售',
      type:'种类型可选',
      navList:[
        {name:'商品'},
        {name:'评价'},
        {name:'推荐'},
        {name:'详情'},
        {name:'属性'}
      ],
      spec:'规格',
      select:'已选商品',
      clear:'清空',
      settle:'去结算',
      num:'数量',
      confirm:'确定',
      cancel: '取消',
      edit: '编辑',
      save: '保存',
      submit: '提交',
      assure:"保障服务",
      guarantee: [
        {name: '正品保证', icon: '', content: '该商品均为原厂正品，有防伪标识与唯一追溯码，100%保证正品。'},
        {name: '7天无理由退款', icon: '', content: '在不影响二次销售的情况下，支持7天无理由退款'}
      ],
      ratingLabels: {
        productScore: '宝贝评分',
        descriptionMatch: '描述相符',
        serviceAttitude: '服务态度',
        deliveryService: '配送服务'
      }
    },
    goodsList:{
      navTitle:'商品列表',
      search:'搜索商品名称',
      default:'默认',
      price:'价格',
      sales:'销量',
      new:'新品',
      empty:'暂无商品，去看点别的吧',
      no: '没有了',
      more: '加载更多',
      nono: '我也是有底线的',
      nomer: '暂无店铺'
    },
    user:{
      navTitle:'我的',
      user:'用户',
      like:'我的收藏',
      integral:'我的积分',
      coupons:'优惠券',
      orderCenter:'订单中心',
      myOrder:'我的订单',
      placeLogin:'请点击登录',
      orderStatus:[
        {name:'待付款'},
        {name:'待发货'},
        {name:'待收货'},
        {name:'待评价'},
        {name:'售后/退款'},
        {name:'已完成'},
        {name:'已收货'}
      ],
      services:'其他服务',
      address:'地址管理',
      contact:'联系客服',
      applicationRecord: '店铺收藏',
      goodsCollection: '商品收藏',
      profile: '个人信息',
      service: '售后服务',
      record: '申请记录',
      mineNav: [
        {name: '我的订单'},
        {name: '退款列表'},
        {name: '评价列表'},
        {name: '钱包'}
      ],
      qunTitle: '商家营业执照信息',
      qunDesc: '根据国家工商总局《网络交易管理办法》要求对网店营业执照信息公示如下：',
      qunCode: '请输入图片验证码',
      submit: '提交',
    },
    goodsSearch:{
      navTitle:'商品搜索',
      place:'点击搜索商品',
      search:'搜索',
      hotSearch:'热门搜索',
      recommend:'热卖推荐',
      emptySearch:'无搜索条件,换个词试试吧',
      placeSearch:'请输入要搜索的商品',
      onSearch:'正在搜索中',
      goods:'商品',
      mer: '店铺',
      merchantType: '店铺类型',
      merchantClassify:'商户分类',
      sure :'确定',
      reset: '重置',
      open: '展开全部',
      up: '收起',
      sort: '排序',
      Default: '默认',
      Seller: '销量',
      Price: '价格',
      searchMer: '抱歉，没有找到您搜索的相关店铺~',
      searchGoods: '抱歉，没有找到您搜索的相关商品~',
    },
    goodsAddcart:{
      navTitle:'购物车',
      labelNav:'100%的产品质量保证和售后服务',
      buyNum:'购买数量',
      management:'管理',
      cancel:'取消',
      attribute:'规格',
      failureGoods:'失效商品',
      empty:'清空',
      failure:'失效',
      fallDesc:'该商品已失效',
      selectAll:'全选',
      buyNow:'立即下单',
      like:'收藏',
      delete:'删除',
      emptyCart:'暂无商品，去添加点什么吧',
      again: '请重新选择商品规格',
      reselect :'重选',
      productInfo: '商品信息',
      unitPrice: '单价',
      quantity: '数量',
      total: '总价',
      operate: '操作',
    },
    orderPayStatus:{
      success:'支付成功',
      fail:'支付失败',
      orderId:'订单编号',
      orderTime:'下单时间',// order of time
      payType:'支付方式',
      payPrice:'支付金额', //Pay the amount
      failReason:'失败原因', //The reason for failure
      viewOrder:'查看订单',//To view the order
      backHome:'返回首页'
    },
    paymentResult:{
      successTip:'您的订单将会尽快发货',
      failTip:'订单支付失败，请重新下单',
      confirm:'确定'
    },
    orderDetails:{
      navTitle:'订单详情',
      item:'件商品',// item(s)
      Customer:'联系客服',
      orderId:'订单编号',
      copy:'复制',
      orderTime:'下单时间',
      refundTime: '退款时间',
      payStatus:'支付状态',
      payTrue:'已支付',
      payFalse:'未支付',
      payType:'支付方式',
      message:'买家留言',
      name:'收货人',
      phone:'联系电话',
      address:'收货地址',
      selfStore: '自提门店',
      storeName: '门店名称',
      contactPerson: '联系人',
      contactPhone: '电话',
      contactEmail: '邮箱',
      storeAddress: '地址',
      returnReason:'退款原因',
      returnMsg:'退款说明',
      returnImg: '退款凭证',
      delivery:'交付方式',
      deliveryOne:'快递',
      deliveryTwo:'自提',
      consigneeInfo: '收货人信息',
      consigneeName: '收货人',
      consigneePhone: '联系电话',
      sendMethod:'配送方式',
      sendOne:'发货', //send
      sendTwo:'送货', //The delivery
      CourierCompany:'快递公司',//Courier company
      CourierNo:'快递单号', //Courier number
      deliveryName:'配送人姓名',
      deliveryPhone:'联系电话',
      Virtual:'虚拟发货',//Virtual delivery
      deliveryMsg:'已发货，请注意查收',
      allPrice:'商品总价',
      freight:'运费',
      coupon:'优惠券抵扣', //Coupon deduction
      point:'积分抵扣', //Points deduction
      actualPayment:'实付款',//actual payment
      cancelOrder:'取消订单',
      nowPay:'立即付款',
      refund:'申请退款',
      logistics:'查看物流',
      confirm:'确认收货',
      delete:'删除订单',
      again:'再次购买',
      applyInvoice:'申请开票',
      confirmInfo: '为保障权益，请收到货确认无误后，再确认收货',
      confirmDel: '确定删除该订单',
      confirmCancel: '确认取消该订单',
      // 地址表单
      formName: '收货人姓名',
      formEmail: '邮箱',
      formEmailCode: '邮箱验证码',
      formPhone: '联系电话',
      formPostCode: '邮政编码',
      formRegion: '所在地区',
      formAddress: '详细地址',
      formCreateAccount: '创建账号？',
      // 占位符
      placeholderName: '请输入收货人姓名',
      placeholderEmail: '请输入邮箱地址',
      placeholderEmailCode: '请输入邮箱验证码',
      placeholderPhone: '请输入联系电话',
      placeholderPostCode: '请输入邮政编码',
      placeholderRegion: '请选择省/市/区',
      placeholderAddress: '请输入详细地址（街道、门牌号等）',
      // 按钮
      sendCode: '发送验证码',
      sendingCode: '秒',
      // 验证提示
      validateName: '请输入收货人姓名',
      validateEmail: '请输入邮箱地址',
      validateEmailFormat: '请输入正确的邮箱格式',
      validateEmailCode: '请输入邮箱验证码',
      validatePhone: '请输入联系电话',
      validatePhoneFormat: '请输入正确的手机号码',
      validatePostCode: '请输入邮政编码',
      validatePostCodeFormat: '请输入6位数字邮政编码',
      validateRegion: '请选择所在地区',
      validateAddress: '请输入详细地址',
      validateAddressLength: '详细地址至少5个字符',
      // 操作提示
      tipEmailFirst: '请先输入邮箱地址',
      tipEmailInvalid: '请输入正确的邮箱地址',
      tipCodeSent: '验证码发送成功，请查收邮件',
      tipCodeFailed: '验证码发送失败，请稍后重试',
      tipFormIncomplete: '请填写完整的地址信息',
      tipSelectRegion: '请选择所在地区',
      tipAddressSaved: '地址保存成功',
      tipAddressFailed: '地址保存失败，请稍后重试',
      tipConsigneeSaved: '收货人信息保存成功',
      tipContactSaved: '联系方式保存成功',
      tipEnterConsignee: '请输入收货人姓名',
      tipEnterContact: '请输入联系电话',
      orderRemark: '订单备注',
      postCode: '邮编',
      region: '地区'
    },
    users:{
      userInfo:{
        navTitle:'设置',
        avatar:'头像',
        name:'昵称',
        email:'用户',
        password:'密码',
        save:'保存修改',
        logOut:'退出登录',
        phone:'电话号码',
        msg: '用户姓名不能为空',
        personalCenter: '个人中心',
      },
      orderConfirm:{
        setAddress:'设置收货地址',
        navTitle:'下单',
        items:'件商品',
        coupons:'优惠券',
        integral:'积分抵扣',
        freight:'快递费用',
        note:'备注信息',
        payPal:'立即结算',
        allPrice:'商品总价',
        remaining:'剩余积分',
        newIntegral:'当前积分',
        free:'免运费',
        placeNote:'请添加备注(150字以内)',
        CouponDeduction:'优惠券抵扣',
        total:'总计',
        payment: '请扫码完成支付',
        paymentResults: '已支付',
        paymentResultsNo: '未支付',
        message:'确定支付该订单吗？', 
        messageTitle:'提示',
        offlinePaymentInfo: '线下支付'
      },
      orderList:{
        navTitle:'我的订单',
        orderNum:'消费订单', //Cumulative order
        total:'总消费',//Total consumption
        orderStatus:[
          {name:'待付款'},
          {name:'待发货'},
          {name:'待收货'},
          {name:'待评价'},
          {name:'售后/退款'},
        ],
        item:'件商品',// item(s)
        totalPay:'总金额',//total payment
        cancelOrder:'取消订单',
        viewDetails:'查看详情',
        evaluation:'去评价',//evaluation
        evaluated:'已评价',//evaluation
        delete:'删除订单',
        empty:'暂无订单信息',
        pay:'立即付款',
        complete:'完成',
        orderInfo: '订单信息',
        afterSale:'售后申请',
      },
      userCoupon:{
        navTitle:'我的优惠券',
        available:'未使用',
        expired:'已使用/过期',
        min:'满减',
        can:'可用',
        used:'过期',
        general:'通用',
        goods:'商品',
        cate:'品类',
        receive:'领取',
        received:'已领取',
        receivedInfo:'领取后',
        receivedInfo1:'天内可用',
        navList:[
          {name:'商家'},
          {name:'商品'},
          {name:'品类'},
        ],
        empty:'暂无优惠券可用',
        valid:'有效期',
        day:'天',
        minus: '减',
        getUsers: '去使用'
      },
      userGoodsCollection:{
        navTitle:'我的收藏',
        item:'件商品',
        management:'管理',
        cancel:'取消',
        empty:'还没有收藏，赶快去关注一波吧~'
      },
      userAddressList:{
        navTitle:'地址管理',
        default:'设为默认',
        add:'添加地址',
        emptyAddress:'暂无地址信息',
        edit:'修改',
        del:'删除',
        sureDel: '确定删除该地址吗'
      },
      userAddress:{
        navTitle:'地址管理',
        name:'姓名',
        Email:'邮箱',
        country:'国家/地区',
        address:'详细地址',
        postCode:'邮政编码',
        phone:'电话号码',
        default:'设为默认',
        save:'保存',
        place:'请输入',
        placeRegion: '请选择省/市/区'
      },
      afterSale: {
        navTitle: '售后管理',
        tabs: {
          apply: '售后申请',
          processing: '处理中',
          completed: '已处理'
        },
        buttons: {
          apply: '申请售后',
          view: '查看详情',
          cancel: '撤销申请',
          fillTracking: '填写快递单号'
        },
        status: {
          returnGoods: '商品待退货',
          refundOnly: '仅退款',
          returnRefund: '退款退货',
          success: '退款成功'
        },
        labels: {
            applyTime: '申请时间',
            applyStatus: '申请状态'
        },
        confirmCancel: '确定要撤销此售后申请吗？',
        cancelSuccess: '撤销成功',
        cancelFailed: '撤销失败'
      },
      userReturnList:{
        navTitle:'申请退货',
        orderId:'退款单号',
        item:'件商品',
        total:'退款金额 ',
        refunding:'退款中',
        refunded:'已退款',
        examine: '商家审核中',
        examineInfo: '您已成功发起退款申请，请耐心等待商家处理；退款前请与商家协商一致，有助于更好的处理售后问题',
        examine1: '商家已退款',
        refuse: '拒绝退款',
        refuseReason: '拒绝原因：',
        refuseReason2: '退款已成功受理，如商家已寄出商品请尽快退回；感谢您的支持',
      },
      goodsCommentList:{
        navTitle:'商品评论',
        score:'评分',
        good:'好评率',
        all:'全部',
        goodScore:'好评',
        general:'中评',
        bad:'差评',
        attribute:'规格',
        seller:'店小二'
      },
      goodsCommentCon:{
        navTitle:'商品评论',
        score:[
          {name:'星级评分'},
          {name: '描述相符'},
          {name:'服务态度'},
          {name: '配送服务'}
        ],
        place:'商品满足你的期待么？说说你的想法，分享给想买的他们吧~' ,
        upload:'上传图片',
        submit:'立即评价',
        tips: '感谢您的评价',
        tipsWrite: '请填写你对宝贝的心得！',
        SU: '评价成功',
        tipsSU:'我们会继续为您提供更优质的商品及服务'

      },
      goodsReturn:{
        navTitle:'申请退款', //Application for return
        number:'退货数量',
        price:'退款金额',
        reason:'退款原因',
        info:'备注说明',
        voucher:'上传凭证',
        place:'填写备注信息，100字以内',
        submit:'申请退款' ,//Request a refund
        upload:'上传凭证',
        detal:'退款单详情',
        information: '退款信息',
        refundList: '退款列表',
        refundType: '退款类型',
        type1: '仅退款',
        type2: '退货退款',
        validateType: '请选择退款类型',
        reasons: [
          '拍错/多拍/不想要',
          '协商一致退款',
          '缺货',
          '未按约定时间发货',
          '其他',
          '商品质量问题',
          '收到的商品破损'
        ]
      },
      trackingDialog: {
        title: '填写快递单号',
        company: '物流公司',
        companyPlaceholder: '请输入物流公司名称',
        trackingNumber: '快递单号',
        trackingNumberPlaceholder: '请输入快递单号',
        remark: '备注说明',
        remarkPlaceholder: '请输入详细内容，选填',
        uploadLabel: '上传凭证',
        uploadTip: '请上传快递单号凭证，选填',
        cancel: '取消',
        confirm: '确定',
        submitSuccess: '提交成功',
        submitFailed: '提交失败',
        validateCompany: '请输入物流公司名称',
        validateTrackingNumber: '请输入快递单号'
      },
      evaluationList: {
        pending: '待评价',
        completed: '已评价',
        goEvaluate: '去评价',
        noPendingOrders: '暂无待评价订单',
        noEvaluationRecords: '暂无评价记录',
        evaluationTime: '评价时间'
      },
      login:{
        placeEmail:'请输入邮箱',
        placePasd:'请输入密码',
        sign:'登录',//SIGN IN
        create:'创建账户', //Create account
        forget:'忘记密码',
        quick:'快速登录',
        pasdLogin:'密码登录',
        with:'第三方登录',
        Pasdagain:'请确认密码',
        submit:'提交',
        next:'下一步',
        reset:'重置密码',
        resetDesc:"请输入您的电子邮件接收验证 ",
        emailVer:"电子邮件验证",
        verDesc:'为了您的帐户安全，请核实您的电子邮件：',
        tourists:'匿名购买',
        continue:'继续',
        phoneVer:'手机号码验证',
        remember: '想起密码了？'
      },
      register:{
        tabNav:[
          {name:'邮箱'},
          {name:'手机号码'}
        ],
        placeEmail:'请输入邮箱',
        placeCode:'请输入验证码',
        placePhone:'请输入手机号码',
        submit:'注册',
        have:'已有账户？',
        sign:'去登录'
      },
      logistics:{
        navTitle:'物流详情',
        expName:'物流公司',
        expNo:'快递单号',
        title:'物流信息',
        company:'物流公司',
        website:'联系网站',
        trackingNo:'物流单号',
      },
      userIntegral:{
        now:'当前积分',
        totalInt:'累计积分',
        totalPay:'累计消费',
        freeze:'冻结积分',
        tabNav:[
          {name:"分值明细"},
          {name:"分值提升"},
        ],
        shopAdd:'购买商品可获得积分奖励',
        make:'赚积分',
        empty:'积分暂无记录'
      },
      replyList: {
        navTitle: '评价列表'
      },
      wallet: {
        navTitle: '我的钱包',
        all: '全部记录',
        income: '收入记录',
        spending: '消费记录',
        cumulativeSpending: '累计消费',
        tableColumn: {
          type: '类型',
          amount: '金额',
          time: '时间'
        }
      },
      invoiceList: {
        navTitle: '发票列表',
        openedCount: '已开具发票',
        applyingCount: '申请中发票',
        orderNum: '订单号',
        applicationTime: '申请时间',
        tableColumn: {
          info: '发票信息',
          amount: '开票金额',
          title: '发票抬头',
          type: '发票类型',
          date: '开票日期',
          status: '开票进度',
          actions: '发票操作',
          type1: '个人',
          type2: '企业'
        },
        status: {
          0: '待审核',
          1: '已同意',
          2: '已驳回'
        },
        actionBtn: {
          viewInvoice: '查看发票',
          orderDetails: '订单详情',
          cancel: '撤销申请'
        }
      },
      afterSaleDetail: {
        returnType: '退货类型',
        consignee: '收件人',
        contact: '联系方式',
        returnAddress: '退货地址',
        copy: '复制',
        refundInfo: '退款信息',
        refundSn: '退款编号',
        table: {
            info: '退款信息',
            quantity: '数量',
            amount: '退款金额',
            reason: '退款原因'
        }
      }
    },
    store: {
      search: '搜索店铺',
      followed: '已收藏',
      follow: '收藏',
      storeRating: '店铺评级',
      storeQualification: '店铺资质',
      storeIntroduction: '店铺简介',
      storeAddress: '店铺地址',
      storePhone: '联系电话',
      storeService: '联系客服',
      storeTime: '开店时间',
      storeName: '商户名称',
      userName: '用户姓名',
      phone: '联系电话',
      emil:'邮箱地址',
      code: '验证码',
      getCode: '获取验证码',
      class:'商户分类',
      type:'店铺类型',
      place1:'请上传营业执照及行业相关资质证明图片',
      place2:'图片最多可上传10张，格式支持JPG、PNG、JPEG',
      agree:'已阅读并同意',
      agreement:'入驻协议',
      submit:'提交申请',
      agreement2:'商户入驻协议',
      Tips1:'恭喜，您的资料提交成功！',
      Tips2:'预计15个工作日内审核完毕，平台客服会及时与您联系！',
      Tips3:'返回首页',
      title1:'商户入驻',
      title2:'来加入我们吧',
      street: '店铺街',
      keyword: '关键字',
      merInfo: '店铺详情',
      index: '首页',
      classify: '分类',
      collar: '领券',
      call: '联系客服',
      people: '人关注',
      delFollow: '取消关注',
      selfSupport: '自营',
      homeNav: [
        {name: '首页'},
        {name: '分类'},
        {name: '领券'}
      ]
    }
  },
  message:{
    login:{
      loginLoading:'正在登录中',
      getting:'获取中',
      emailEmpty:'请填写邮箱',
      correctEmail:'请填写正确的邮箱',
      emptyPassword:'请填写密码',
      againPassword:'请确认密码',
      diffPassword:'两遍密码不一致',
      emptyPhone:'请填写手机号码',
      emptyCaptche:'请填写验证码',
      correctCaptche:'请填写正确的验证码',
      loginSuccess:'登录成功',
      resetSuccess:'密码重置成功',
      name:'请填写收货人姓名',
      detail:'请填写详细地址',
      postCode:'请填写邮政编码',
      save:'正在保存中',
      updateSU:'修改成功',
      saveSU:'保存成功',
      prompt:'提示',
      country: '请选择地区',
      confirmDel:'确定删除吗?',
      logout:'确定退出登录吗?',
      notExist:'您设置的默认地址不存在',
      setSU:'设置成功',
      delSU:'删除成功',
      calSU:'取消成功',
      send:'发送',
      resend:'重新发送',
      remaining:'剩余',
      operationSU: '操作成功',
      loginSure: '修改之后使用该密码保持登录吗？',
      loginFacebook:'当前用户未登录Facebook或者您的网页',
      registerSU:'注册成功',
      agreement: '请勾选用户隐私协议',
      agree: '我已阅读并同意',
      agreementName: '用户协议'
    },
    pay:{
      orderFail:'支付失败',
      error:'缺少参数无法查看订单支付状态',
      errorOrder: '缺少订单号无法查看'
    },
    orderConfirm:{
      payType:'请选择支付方式',
      emptyAddress:'请选择收货地址',
      payLoading:'订单支付中',
      productInfo: '商品信息',
      confirmPay: '确定支付该订单吗',
      prompt: '提示',
      orderCreateFail: '订单创建失败',
      orderCreateFailMsg: '订单创建失败，请稍后重试',
      mercadoMinAmountTip: '使用mercado支付时金额必须大于3，请换其他方式支付'
    },
    tips: {
      time: '提交时间',
      adopt:'审核通过',
      noadopt: '审核未通过',
      reason: '原因',
      stay: '待审核',
      edit: '编辑',
      see: '查看',
      again: '重新提交',
      shoppingSU: '添加购物车成功',
      addingToCart: '正在加入购物车...',
      loding: '加载中...',
      selectAddress: '选择地址',
      selectOther: '选择其他地址',
      surePay: '确定支付订单吗',
      sureDel: '确定删除该订单',
      upPic:'最多可上传5张',
      edidM: '点击修改密码',
      sold: '售出',
      changeGoods: '请选择商品',
      picTips: '上传图片只能是 JPG、PNG 格式',
      noEvaluation: '暂无评论~',
      more: '显示更多',
      hide: '隐藏更多',
      noDetal: '暂无商品详情',
      getSU: '领取成功',
      browser: '由于360浏览器功能限制，请按 Ctrl+D 手动收藏!',
      nubrowser: '您的浏览器不支持,请按 Ctrl+D 手动收藏!',
      error1: '抱歉，您访问的页面出错了',
      error2: '加载失败',
      error3:'错误的请求',
      error4:'请检查您的配置文件',
      placeLogin: '请登录',
      selectSku: '请选择商品规格',
      cancelCollect: '操作成功',
      noComment: '此用户没有填写评价',
      getDetailFailed: '获取商品详情失败'
    },
    settled: {
      emptyName:"请输入企业名称",
      emptyRealName:"请输入姓名",
      emptyCaptcha:"请填写验证码",
      emptyCategory:"请选择商户分类",
      emptyIsAgree:"请勾选并同意入驻协议",
      emptyIsPicture:"请上传资质图片",
      appleTips: '暂无申请记录，快去申请入驻吧'
    },
    common: {
      confirm: '确定',
      cancel: '取消'
    }
  },
  router: {
    home: '首页',
    users: '用户中心',
    addressList: '地址列表',
    applicationRecord: '申请记录',
    collectionList: '收藏列表',
    couponList: '优惠券列表',
    evaluationConfirm: '评价确认',
    evaluationList: '评价列表',
    invoiceList: '发票列表',
    merchantSettled: '商户入驻',
    orderList: '订单列表',
    afterSale: '售后',
    refundConfirm: '退款确认',
    refundList: '退款列表',
    userInfo: '用户信息',
    wallet: '我的钱包',
    activityList: '活动列表',
    goodsSearch: '商品搜索',
    topOne: '排行榜',
    goodsDetail: '商品详情',
    merchant: '商户',
    merchantMore: '更多商户',
    merchantStreet: '商户街',
    merchantCategory: '商户分类',
    merchantCoupon: '商户优惠券',
    merchantHome: '商户主页',
    merchantQualification: '商户资质',
    callbackTwitter: 'Twitter 回调',
    privacyAgreement: '隐私协议',
    about: '关于我们',
    contact: '联系我们',
    orderConfirm: '订单确认',
    orderDetail: '订单详情',
    paymentResult: '支付结果',
    refundDetail: '退款详情',
    shoppingCart: '购物车',
    stripePayment: 'Stripe 支付',
    news: '新闻资讯',
    newsDetail: '新闻详情',
    trackOrder: '订单查询',
    
  }
}
